import { clientInfo } from 'configureBrand'
import config from 'const/config'
import { getCorrelationId } from 'helpers'
import { isBrowser, isMobileOnly, isTablet } from 'react-device-detect'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import getBrowser from 'syf-js-utilities/helpers/getBrowser'

const useCustomerData = () => {
  const { isIdpFlow, isWebApp, returnTo } = useSelector((state: RootState) => ({
    isIdpFlow: state.idp.isIdpFlow,
    isWebApp: state.jwt.isWebApp,
    returnTo: state.jwt.returnTo
  }))

  const deviceView = (() => {
    if (isMobileOnly) return 'Mobile'
    if (isTablet) return 'Tablet'
    if (isBrowser) return 'Desktop'
    return 'Unknown'
  })()

  const isPartnerConnect = /partner-connect/.test(returnTo)

  const determineSignInto = () => {
    if (isPartnerConnect) {
      return 'Synchrony Travel'
    }

    return isWebApp ? 'Account Manager' : 'MySynchrony App'
  }

  const domain =
    clientInfo.displayName === 'Synchrony Financial'
      ? `${clientInfo.displayName} (${config.RC_CLIENT_ID.toUpperCase()})`
      : clientInfo.displayName

  return {
    deviceView,
    browser: getBrowser()?.toString() ?? 'Unknown',
    domain,
    sessionId: getCorrelationId(),
    signingInto: !isIdpFlow ? 'eService' : determineSignInto()
  }
}

export default useCustomerData
